import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 407.436 407.436" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M315.869 21.178L294.621 0 91.566 203.718l203.055 203.718 21.248-21.178-181.945-182.54z" /></svg>;